export const ScreenSize = {
  w: 1920,
  h: 1080,
};
